
export enum DictTier {
	device = 1,
	area = 2,
	location = 4,
	corporation = 8,
	dealer = 16,
}

export enum DictComponentEventType {
	All = 0,
	Alert = 1,
	Information = 2,
}

export enum DeviceDeviceStatus {
	Unknown = 0,
	Active = 1,
	InActive = 2,
	Locked = 3,
}

/// using bit flags for enum (power of 2)
///
/// var left_right = MyEnum.Left | MyEnum.Right;
/// if ( (left_right & MyEnum.Left) == MyEnum.Left) {...}
/// more: http://www.pzielinski.com/?p=928
export enum DictFunctionalitiesType {
	// Unknown = 0,
	// None = 1,
	CashDeposit = 1,
	DigitalSignage = 2,
	Surveys = 4,
	//next one  = 8
}

/// using bit flags for enum (power of 2)
///
/// var left_right = MyEnum.Left | MyEnum.Right;
/// if ( (left_right & MyEnum.Left) == MyEnum.Left) {...}
/// more: http://www.pzielinski.com/?p=928
export enum DictComponentsType {
	Terminal = 1,
	Printer = 2,
	Monitor = 4,
	//next one = last one ^2, remember to fill up ComponentTypes
}

export enum DictImageType {
	Logo = 1,
	SidePicture = 2,
	Goal = 3,
	AboutPicture = 6,
	MainPicture = 7
}
